export default __webpack_public_path__ + "static/media/Nav-Message.193987c3.svg";